import './BackofficeConfigurationTabSkeletonLoader.scss';

const BackofficeConfigurationTabSkeletonLoader = () => {
  return (
    <div className="backofficeConfigurationTabSkeletonLoader">
      <div className="addAndRemove">
        <div className="skeletonTitle animationLoader" />
        <div className="skeletonSubtitle animationLoader" />
        <div className="skeletonEmailAndButton">
          <div className="skeletonInput animationLoader" />
          <div className="skeletonButton animationLoader" />
        </div>
      </div>
      <div className="dividerLine" />
      <div className="addAndRemove">
        <div className="skeletonTitle animationLoader" />
        <div className="skeletonSubtitle animationLoader" />
        <div className="skeletonEmailAndButton">
          <div className="skeletonInput animationLoader" />
          <div className="skeletonButton animationLoader" />
        </div>
      </div>
      <div className="dividerLine" />
      <div className="skeletonUsersPermissionsGroups">
        <div className="skeletonTitle animationLoader" />
        <div className="skeletonPermissionsTitles">
          <div className="left">
            <div className="mb-4 skeletonText small animationLoader" />
            {[0, 1, 2, 3].map(number => {
              return (
                <div className="skeletonUser" key={number}>
                  {number % 2 === 0 && <div className="mt-2 skeletonText medium animationLoader" />}
                  {number % 2 !== 0 && <div className="mt-2 skeletonText small animationLoader" />}
                </div>
              );
            })}
          </div>
          <div className="right">
            <div className="mb-4 skeletonText medium animationLoader" />
            {[0, 1, 2, 3].map(number => {
              return (
                <div className="skeletonUser" key={number}>
                  <div className="skeletonInput animationLoader" />
                  <div className="mb-4 skeletonButton animationLoader" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="marginAtBottom w-20 h-10" />
    </div>
  );
};

export default BackofficeConfigurationTabSkeletonLoader;
